"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorGridWidget = exports.ColorSwatchWidget = exports.DataColorAttr = void 0;
var tslib_1 = require("tslib");
var tableau_ui_1 = require("@tableau/tableau-ui");
var React = tslib_1.__importStar(require("react"));
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var FocusIndicators_1 = require("../../styles/FocusIndicators");
var TabStyles_1 = require("../../styles/TabStyles");
var Declarative_1 = require("../../utils/Declarative");
var ReactHelpers_1 = require("../../utils/ReactHelpers");
var ColorPickerPresets_1 = require("./ColorPickerPresets");
var ColorSwatchSize = 15;
var ColorSwatchStyleName = TypeStyle.style({
    boxSizing: 'border-box',
    height: ColorSwatchSize,
    width: ColorSwatchSize,
    $nest: {
        '&:hover, &:active, &[aria-selected="true"]': { position: 'relative' },
        '&:focus-visible': tslib_1.__assign({ position: 'relative' }, FocusIndicators_1.DefaultFocusIndicator({ outlineOffset: -1, inset: true })),
        '&[aria-selected="true"]::after': { outline: "1px solid " + TabStyles_1.TabStyles.Colors.L8 },
        '&:hover::after, &:active::after': { outline: "1px solid " + TabStyles_1.TabStyles.Colors.L9 },
        '&:hover::after, &:active::after, &[aria-selected="true"]::after': {
            border: "1px solid white",
            bottom: -1,
            content: "\"\"",
            left: -1,
            pointerEvents: 'none',
            position: 'absolute',
            right: -1,
            top: -1,
        },
    }
});
exports.DataColorAttr = 'data-color';
exports.ColorSwatchWidget = React.memo(React.forwardRef(function (props, ref) {
    var _a;
    var propsColor = props.color, className = props.className, disabled = props.disabled, onClick = props.onClick, selected = props.selected, size = props.size, style = props.style, testId = props.testId, htmlAttrs = tslib_1.__rest(props, ["color", "className", "disabled", "onClick", "selected", "size", "style", "testId"]);
    var color = propsColor.toLowerCase();
    var handleClick = React.useCallback(function () { return onClick(color); }, [onClick, color]);
    return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    React.createElement("div", tslib_1.__assign({}, ReactHelpers_1.EventUtilsOptOut, { "aria-disabled": disabled, "aria-label": color, "aria-selected": selected, "data-tb-test-id": Declarative_1.makeTestId(testId, 'ColorSwatch', color) }, htmlAttrs, { className: TypeStyle.classes(className, ColorSwatchStyleName, disabled && 'disabled') }, (_a = {}, _a[exports.DataColorAttr] = color, _a), { onClick: disabled ? undefined : handleClick, ref: ref, style: tslib_1.__assign({ backgroundColor: color, height: size, width: size }, style) })));
}));
exports.ColorSwatchWidget.displayName = 'ColorSwatchWidget';
var ColorGridWidget = /** @class */ (function (_super) {
    tslib_1.__extends(ColorGridWidget, _super);
    function ColorGridWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ColorGridWidget.prototype.render = function () {
        var _a = this.props, colorsPreset = _a.colorsPreset, handleSwatchClicked = _a.handleSwatchClicked, selectedColor = _a.selectedColor, testId = _a.testId, htmlAttrs = tslib_1.__rest(_a, ["colorsPreset", "handleSwatchClicked", "selectedColor", "testId"]);
        var preset = ColorPickerPresets_1.ColorPickerPresets[colorsPreset];
        return React.createElement(tableau_ui_1.ColorGrid, tslib_1.__assign({}, ReactHelpers_1.EventUtilsOptOut, { "aria-label": preset.label(), "data-tb-test-id": Declarative_1.makeTestId(testId, 'ColorGrid') }, htmlAttrs, { onColorChange: handleSwatchClicked, palette: preset.palette, selectedColor: selectedColor }));
    };
    ColorGridWidget.defaultProps = { colorsPreset: ColorPickerPresets_1.ColorGridPreset.Dark };
    return ColorGridWidget;
}(React.PureComponent));
exports.ColorGridWidget = ColorGridWidget;
//# sourceMappingURL=ColorGridWidget.js.map